/* Henson FR — interactions & effects */
(function () {
  "use strict";
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Scroll progress bar ---- */
  var progress = document.createElement("div");
  progress.className = "scroll-progress";
  document.body.appendChild(progress);
  function updateProgress() {
    var h = document.documentElement;
    var scrolled = (h.scrollTop) / (h.scrollHeight - h.clientHeight);
    progress.style.width = Math.min(scrolled * 100, 100) + "%";
  }
  window.addEventListener("scroll", updateProgress, { passive: true });
  updateProgress();

  /* ---- Split headlines into words ---- */
  document.querySelectorAll("[data-split]").forEach(function (el) {
    var html = el.innerHTML;
    // split by spaces but keep <br> and tags
    var parts = html.split(/(\s+|<br\s*\/?>)/i);
    var out = "";
    parts.forEach(function (p) {
      if (/^\s+$/.test(p)) { out += p; return; }
      if (/^<br/i.test(p)) { out += p; return; }
      if (!p) return;
      out += '<span class="word"><span>' + p + "</span></span>";
    });
    el.innerHTML = out;
  });

  /* ---- Reveal observers (single, stagger, split) ---- */
  function observe(sel, cls) {
    var els = document.querySelectorAll(sel);
    if (!("IntersectionObserver" in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add(cls); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add(cls);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -6% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }
  observe("[data-reveal]", "is-in");
  observe("[data-reveal-stagger]", "is-in");
  observe("[data-split]", "is-in");

  /* ---- Parallax on [data-parallax] ---- */
  if (!reduceMotion && "IntersectionObserver" in window) {
    var pEls = document.querySelectorAll("[data-parallax]");
    var pVisible = new Set();
    var pio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) pVisible.add(e.target);
        else pVisible.delete(e.target);
      });
    }, { threshold: 0 });
    pEls.forEach(function (el) { pio.observe(el); });
    var ticking = false;
    function onScrollParallax() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        pVisible.forEach(function (el) {
          var speed = parseFloat(el.getAttribute("data-parallax")) || 0.15;
          var rect = el.getBoundingClientRect();
          var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -speed;
          el.style.transform = "translate3d(0," + offset.toFixed(1) + "px,0)";
        });
        ticking = false;
      });
    }
    window.addEventListener("scroll", onScrollParallax, { passive: true });
    onScrollParallax();
  }

  /* ---- Count-up stats ---- */
  function animateCount(el) {
    var raw = el.getAttribute("data-count") || el.textContent;
    var target = parseInt(raw.replace(/[^\d]/g, ""), 10) || 0;
    var suffix = el.getAttribute("data-suffix") || "";
    var small = target <= 20;
    var dur = 1500, start = null;
    function fmt(n) {
      if (target >= 1000) { return Math.round(n / 1000) + "K"; }
      return Math.round(n).toString();
    }
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (small ? Math.round(target * eased) : fmt(target * eased)) + (p === 1 ? suffix : "");
      if (p < 1) requestAnimationFrame(step);
      else { el.classList.add("is-counted"); }
    }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll("[data-count]");
  if ("IntersectionObserver" in window && !reduceMotion) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          cio.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(function (c) { cio.observe(c); });
  }

  /* ---- Magnetic buttons ---- */
  if (!reduceMotion && window.matchMedia("(pointer:fine)").matches) {
    document.querySelectorAll("[data-magnetic]").forEach(function (btn) {
      var strength = 18;
      btn.addEventListener("mousemove", function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width;
        var y = (e.clientY - r.top - r.height / 2) / r.height;
        btn.style.transform = "translate(" + (x * strength).toFixed(1) + "px," + (y * strength).toFixed(1) + "px)";
      });
      btn.addEventListener("mouseleave", function () { btn.style.transform = ""; });
    });
  }

  /* ---- Marquee duplication safety ---- */
  var track = document.querySelector("[data-marquee-track]");

  /* ---- Sticky header condense ---- */
  var header = document.querySelector("[data-site-header]");
  if (header) {
    window.addEventListener("scroll", function () {
      if (window.scrollY > 80) header.classList.add("is-stuck");
      else header.classList.remove("is-stuck");
    }, { passive: true });
  }

  /* ---- Mobile menu ---- */
  var toggle = document.querySelector("[data-menu-toggle]");
  var menu = document.querySelector("[data-mobile-menu]");
  if (toggle && menu) {
    toggle.addEventListener("click", function () {
      var hidden = menu.hasAttribute("hidden");
      if (hidden) { menu.removeAttribute("hidden"); document.body.style.overflow = "hidden"; }
      else { menu.setAttribute("hidden", ""); document.body.style.overflow = ""; }
    });
    menu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        menu.setAttribute("hidden", "");
        document.body.style.overflow = "";
      });
    });
  }

  /* ---- Newsletter (demo) ---- */
  var news = document.querySelector("[data-newsletter]");
  if (news) {
    news.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = news.querySelector("button");
      var input = news.querySelector("input");
      var orig = btn.textContent;
      btn.textContent = "Merci ✓";
      input.value = "";
      input.placeholder = "Inscription confirmée";
      setTimeout(function () { btn.textContent = orig; }, 2600);
    });
  }

  /* ============================================================
     PDP — Page produit
     ============================================================ */

  /* ---- Gallery: thumbnail switch ---- */
  var gallery = document.querySelector("[data-gallery]");
  var galleryMainImg = gallery ? gallery.querySelector("[data-gallery-main] img") : document.querySelector("[data-gallery-main] img");

  function switchMainImage(baseUrl) {
    if (!galleryMainImg || !baseUrl) return;
    var base = baseUrl.split("?")[0];
    var widths = [375, 560, 750, 960, 1200, 1600];
    var srcset = widths.map(function (w) { return base + "?width=" + w + " " + w + "w"; }).join(", ");
    galleryMainImg.style.opacity = "0";
    setTimeout(function () {
      galleryMainImg.setAttribute("src", base + "?width=1600");
      galleryMainImg.setAttribute("srcset", srcset);
      galleryMainImg.setAttribute("sizes", "(max-width: 900px) 100vw, 55vw");
      galleryMainImg.style.opacity = "1";
    }, 150);
  }

  if (gallery) {
    var thumbs = gallery.querySelectorAll("[data-thumb]");
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-thumb");
        switchMainImage(src);
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  }

  /* ---- Variant selection ---- */
  var pdpSection = document.querySelector("section[data-section='product-template']");
  var pdpForm = document.querySelector(".pdp__form");
  var optionGroups = document.querySelectorAll(".pdp__option");
  var hiddenIdInput = document.querySelector('.pdp__form input[name="id"]');
  var priceSaleEl = document.querySelector(".pdp__price-sale");
  var priceRegEl = document.querySelector(".pdp__price-reg");
  var originalAddLabel = null;
  var addBtn = document.querySelector(".pdp__add");
  if (addBtn) {
    var lblEl = addBtn.querySelector(".pdp__add-label") || addBtn;
    originalAddLabel = lblEl.textContent || "Ajouter au panier";
  }

  var variants = [];
  // Lire depuis l'attribut data-product du <section> (JSON complet du produit, plus fiable)
  if (pdpSection && pdpSection.getAttribute("data-product")) {
    try {
      var p = JSON.parse(pdpSection.getAttribute("data-product"));
      if (p && Array.isArray(p.variants)) variants = p.variants;
    } catch (e) { variants = []; }
  }
  // Fallback sur l'ancien attribut data-variants du form
  if (!variants.length && pdpForm && pdpForm.getAttribute("data-variants")) {
    try { variants = JSON.parse(pdpForm.getAttribute("data-variants")); } catch (e) { variants = []; }
  }

  var moneyFmt = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : "{{amount}} €";
  function formatMoney(cents) {
    if (cents == null) return "";
    var amt = (cents / 100).toFixed(2).replace(".", ",");
    return moneyFmt.replace("{{amount}}", amt).replace("{{amount_with_comma_separator}}", amt);
  }

  function getSelectedOptions() {
    var selected = [];
    optionGroups.forEach(function (group) {
      var active = group.querySelector(".pdp__option-value.is-active");
      if (active) selected.push(active.getAttribute("data-value"));
      else selected.push(null);
    });
    return selected;
  }

  function findVariant() {
    if (!variants.length) return null;
    var sel = getSelectedOptions();
    return variants.find(function (v) {
      return v.options.every(function (opt, i) {
        if (sel[i] == null || sel[i] === "") return true; // option non choisie = wildcard
        return String(opt) === String(sel[i]);
      });
    }) || variants.find(function (v) {
      // fallback: correspondance partielle sur la 1ère option (la couleur en général)
      return sel[0] != null && String(v.options[0]) === String(sel[0]);
    });
  }

  function updateVariant() {
    if (!variants.length) return;
    var variant = findVariant();
    if (!variant) return;
    if (hiddenIdInput) hiddenIdInput.value = variant.id;

    if (priceSaleEl && variant.price != null) priceSaleEl.textContent = formatMoney(variant.price);
    if (priceRegEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceRegEl.textContent = formatMoney(variant.compare_at_price);
        priceRegEl.style.display = "";
      } else {
        priceRegEl.style.display = "none";
      }
    }

    // Mettre à jour l'image principale avec celle du variant
    if (variant.featured_image) {
      var fi = variant.featured_image;
      var newSrc = (typeof fi === "string") ? fi : (fi.src || null);
      if (newSrc) {
        switchMainImage(newSrc);
        var allThumbs = document.querySelectorAll("[data-thumb]");
        var variantBase = newSrc.split("?")[0];
        allThumbs.forEach(function (t) {
          var thumbBase = (t.getAttribute("data-thumb") || "").split("?")[0];
          if (thumbBase && (thumbBase === variantBase || variantBase.indexOf(thumbBase) === 0 || thumbBase.indexOf(variantBase) === 0)) {
            allThumbs.forEach(function (x) { x.classList.remove("is-active"); });
            t.classList.add("is-active");
          }
        });
      }
    }

    if (addBtn) {
      if (variant.available === false) {
        var label = addBtn.querySelector(".pdp__add-label") || addBtn;
        label.textContent = "Épuisé";
        addBtn.disabled = true;
        addBtn.style.opacity = "0.5";
      } else {
        addBtn.disabled = false;
        addBtn.style.opacity = "";
        var lbl = addBtn.querySelector(".pdp__add-label") || addBtn;
        if (originalAddLabel) lbl.textContent = originalAddLabel;
      }
    }
  }

  /* Basic toggle (works with or without variant data) */
  optionGroups.forEach(function (group) {
    var values = group.querySelectorAll(".pdp__option-value");
    values.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        values.forEach(function (v) { v.classList.remove("is-active"); });
        btn.classList.add("is-active");
        updateVariant();
      });
    });
  });

  // Initial call (au cas où les options par défaut ne seraient pas le 1er variant)
  updateVariant();

  /* ---- AJAX Ajout au panier (Shopify /cart/add.js) ---- */
  function refreshCartCount() {
    // Mettre à jour le compteur du header via /cart.js JSON
    var cartCountEl = document.querySelectorAll("[data-cart-count], .header__cart-count, .cart-count");
    if (!cartCountEl.length) return;
    fetch("/cart.js", { credentials: "same-origin", headers: { "Accept": "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var c = (cart.item_count != null) ? String(cart.item_count) : "";
        cartCountEl.forEach(function (el) {
          el.textContent = c;
          if (!c || c === "0") el.style.display = "none";
          else el.style.display = "";
        });
      })
      .catch(function () { /* silent */ });
  }

  function setAddLoading(loading, errMsg) {
    if (!addBtn) return;
    var lbl = addBtn.querySelector(".pdp__add-label") || addBtn;
    if (loading) {
      addBtn.disabled = true;
      lbl.setAttribute("data-original", lbl.textContent);
      lbl.textContent = "Ajout…";
      addBtn.style.opacity = "0.7";
    } else {
      addBtn.disabled = false;
      addBtn.style.opacity = "";
      var orig = lbl.getAttribute("data-original") || originalAddLabel;
      if (errMsg) {
        lbl.textContent = errMsg;
        setTimeout(function () { lbl.textContent = orig; }, 2200);
      } else {
        lbl.textContent = "Ajouté ✓";
        setTimeout(function () { lbl.textContent = orig; }, 1400);
      }
    }
  }

  if (pdpForm) {
    function addOneItem(id, qty) {
      var fd = new FormData();
      fd.append("id", String(id));
      fd.append("quantity", String(qty || 1));
      return fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: fd
      }).then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error(t || "HTTP " + r.status); });
        return r.json();
      });
    }

    pdpForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var idEl = pdpForm.querySelector('input[name="id"]');
      var qtyEl = pdpForm.querySelector('input[name="quantity"]');
      var id = idEl ? idEl.value : null;
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      if (!id) { pdpForm.submit(); return; }

      // Collecter items : produit principal + lame selectionnee + accessoires coches
      var toAdd = [{ id: parseInt(id, 10), qty: qty }];
      var bladeRadio = document.querySelector('input[name="blade-option"]:checked');
      if (bladeRadio) {
        var bid = parseInt(bladeRadio.getAttribute("data-blade-variant"), 10);
        if (bid) toAdd.push({ id: bid, qty: 1 });
      }
      var accChecks = document.querySelectorAll('input[name="accessory-option"]:checked');
      accChecks.forEach(function (cb) {
        var aid = parseInt(cb.getAttribute("data-acc-variant"), 10);
        if (aid) toAdd.push({ id: aid, qty: 1 });
      });

      setAddLoading(true);
      // Ajouter un par un (compatibilite maximale avec toutes les versions Shopify)
      var chain = Promise.resolve();
      toAdd.forEach(function (it) {
        chain = chain.then(function () { return addOneItem(it.id, it.qty); });
      });
      chain.then(function () {
        setAddLoading(false);
        refreshCartCount();
        if (typeof window.drawer === "object" && window.drawer.open) {
          try { window.drawer.open("cart"); } catch (err) {}
        }
        var cartDrawer = document.getElementById("cartDrawer");
        if (cartDrawer && !cartDrawer.hasAttribute("open")) {
          try { cartDrawer.setAttribute("open", ""); } catch (err) {}
        }
      }).catch(function (err) {
        var msg;
        if (err && err.message) {
          var m = String(err.message).toLowerCase();
          if (m.indexOf("sold out") >= 0 || m.indexOf("unavailable") >= 0) msg = "Stock insuffisant";
          else msg = "Erreur: reessayez";
        } else {
          msg = "Erreur, reessayez";
        }
        refreshCartCount();
        setAddLoading(false, msg);
      });
    });
  }

  /* ---- FAQ: exclusive open (accordion) ---- */
  var faqList = document.querySelector("[data-faq]");
  if (faqList) {
    var faqItems = faqList.querySelectorAll(".pdp-faq__item");
    faqItems.forEach(function (item) {
      item.addEventListener("toggle", function () {
        if (item.open) {
          faqItems.forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
        }
      });
    });
  }

  /* ---- Add-on radio exclusivity (blades) ---- */
  var bladeRadios = document.querySelectorAll('input[name="blades"]');
  bladeRadios.forEach(function (radio) {
    radio.addEventListener("change", function () {
      var addon = radio.closest(".pdp__addon");
      if (addon && radio.checked) {
        var siblings = addon.parentElement.querySelectorAll('.pdp__addon input[name="blades"]');
        siblings.forEach(function (s) {
          var sBox = s.closest(".pdp__addon");
          if (sBox && s !== radio) sBox.classList.remove("is-selected");
        });
        addon.classList.add("is-selected");
      }
    });
  });

  /* ---- Cartes produits : AJAX ajouter au panier ---- */
  function setCardLoading(btn, loading, errMsg) {
    if (!btn) return;
    if (loading) {
      btn.classList.add("is-loading");
      btn.setAttribute("data-orig", btn.textContent);
      btn.disabled = true;
      btn.textContent = "Ajout...";
    } else {
      btn.classList.remove("is-loading");
      btn.disabled = false;
      var orig = btn.getAttribute("data-orig") || "Ajouter au panier";
      if (errMsg) {
        btn.textContent = errMsg;
        setTimeout(function () { btn.textContent = orig; }, 2200);
      } else {
        btn.textContent = "Ajoute !";
        setTimeout(function () { btn.textContent = orig; }, 1500);
      }
    }
  }

  var cardForms = document.querySelectorAll("[data-card-form]");
  cardForms.forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var idEl = form.querySelector('input[name="id"]');
      var qtyEl = form.querySelector('input[name="quantity"]');
      var btn = form.querySelector('button[type="submit"]');
      if (!idEl || !idEl.value) { form.submit(); return; }
      var id = idEl.value;
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      var body = new FormData();
      body.append("id", String(id));
      body.append("quantity", String(qty));
      setCardLoading(btn, true);
      fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: body
      }).then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error(t || r.status); });
        return r.json();
      }).then(function () {
        setCardLoading(btn, false);
        if (typeof refreshCartCount === "function") refreshCartCount();
      }).catch(function (err) {
        var msg = (err && err.message && String(err.message).toLowerCase().indexOf("all items sold") >= 0) ? "Stock insuffisant" : "Erreur, reessayez";
        setCardLoading(btn, false, msg);
      });
    });
  });

  /* ============================================================
     Cart page — AJAX update / remove
     ============================================================ */
  var cartForm = document.querySelector("[data-cart-form]");
  if (cartForm) {
    function formatMoney(cents) {
      var fmt = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : "{{amount}} €";
      var amt = (cents / 100).toFixed(2).replace(".", ",");
      return fmt.replace("{{amount}}", amt).replace("{{amount_with_comma_separator}}", amt);
    }

    function updateCartLine(line, quantity) {
      return fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Accept": "application/json", "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
    }

    function refreshCartUI(cart) {
      var subtotalEl = document.querySelector("[data-cart-subtotal]");
      if (subtotalEl && cart.total_price != null) subtotalEl.textContent = formatMoney(cart.total_price);
      var countEls = document.querySelectorAll("[data-cart-count]");
      countEls.forEach(function (el) {
        var c = String(cart.item_count);
        el.textContent = c;
        el.style.display = (!c || c === "0") ? "none" : "";
      });
      if (cart.item_count === 0) {
        window.location.reload();
      }
    }

    // Qty + / - buttons
    cartForm.addEventListener("click", function (e) {
      var decBtn = e.target.closest("[data-qty-dec]");
      var incBtn = e.target.closest("[data-qty-inc]");
      if (!decBtn && !incBtn) return;
      var line = (decBtn || incBtn).getAttribute("data-line");
      var input = cartForm.querySelector('[data-qty-input][data-line="' + line + '"]');
      if (!input) return;
      var qty = parseInt(input.value, 10) || 0;
      if (decBtn) qty = Math.max(0, qty - 1);
      if (incBtn) qty = qty + 1;
      input.value = qty;
      updateCartLine(parseInt(line, 10), qty).then(refreshCartUI).catch(function () {});
    });

    // Qty input change
    cartForm.addEventListener("change", function (e) {
      var input = e.target.closest("[data-qty-input]");
      if (!input) return;
      var line = parseInt(input.getAttribute("data-line"), 10);
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      updateCartLine(line, qty).then(refreshCartUI).catch(function () {});
    });

    // Remove button
    cartForm.addEventListener("click", function (e) {
      var removeBtn = e.target.closest("[data-cart-remove]");
      if (!removeBtn) return;
      e.preventDefault();
      var line = parseInt(removeBtn.getAttribute("data-line"), 10);
      var item = removeBtn.closest("[data-cart-item]");
      if (item) item.style.opacity = "0.5";
      updateCartLine(line, 0).then(function (cart) {
        if (item) item.remove();
        refreshCartUI(cart);
      }).catch(function () { if (item) item.style.opacity = ""; });
    });
  }
})();
